module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0057.jpg?v=879b7f9b";